<template>
  <section class="page-section values-page" data-page="3">
    <div class="page-container">
      <h2 class="page-title">
        <span class="title-highlight">核心价值</span>
        <span class="title-subtitle">Core Values</span>
      </h2>
      <div class="about-cards-compact">
        <div 
          class="value-card-compact" 
          v-for="(item, index) in cards" 
          :key="index"
          :style="{ animationDelay: `${index * 0.2}s` }"
        >
          <div class="card-background"></div>
          <div class="card-content">
            <div class="card-icon-large">{{ getCardIcon(index) }}</div>
            <h3>{{ item.title }}</h3>
            <p v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CoreValues',
  data() {
    return {
      cards: [
        { title: "我们的使命", description: "科技赋能 融合创新<br><br>全领域焕活遗产保护" },
        { title: "我们的愿景", description: "传承历史文脉 赓续盛世华章" },
        { title: "我们的价值观", description: "传承 创新 协同 共赢" }
      ]
    };
  },
  methods: {
    getCardIcon(index) {
      const icons = ['🎯', '🌟', '💎'];
      return icons[index] || '⭐';
    }
  }
};
</script>

<style scoped>
.values-page {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  color: white;
}

.about-cards-compact {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
  height: 70%;
  align-items: center;
}

.value-card-compact {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.value-card-compact:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.card-icon-large {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.value-card-compact h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 15px 0 10px 0;
  color: #ffffff;
}

.value-card-compact p {
  font-size: 0.85rem;
  line-height: 1.5;
  opacity: 0.9;
  margin: 0;
}

@media (max-width: 1024px) {
  .about-cards-compact {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
    .about-cards-compact {
        gap: 60px; /* 适中的间距 */
        padding: 0 15px;
    }
    .value-card-compact {
        padding: 10px; /* 增加内边距 */
        max-width: 400px;

    }
}
</style>